export default __webpack_public_path__ + "static/media/volleyball.80a8aa26.svg";